module.exports = __webpack_public_path__ + "img/15.6.CODm.cd554970.png";